import GenerateCustomReportContainer from "./GenerateCustomReportContainer";
export default GenerateCustomReportContainer;
